import {
  createContext,
  createElement,
  useContext,
  useMemo,
  useReducer,
  type Dispatch,
  type ReactElement,
} from 'react';
import type { State } from './types';
import { reducer, type Mutation } from './mutations';

export interface TagsStore {
  state: State;
  dispatch: Dispatch<Mutation>;
}

const TagsContext = createContext<TagsStore>({} as TagsStore);

export function TagsStoreProvider({ children }: { children: ReactElement }) {
  const [state, dispatch] = useReducer(reducer, {
    lookup: {},
    list: [],
    loaded: false,
  });
  const props = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return createElement(TagsContext.Provider, { value: props }, children);
}

export function useTagsStore() {
  return useContext(TagsContext);
}
